export const PLAYER_NAME = {
    'WECHAT': 'wechat',
    'BROWSER': 'browser'
}
